export const deobfuscate = (e) => {
  const target = e.target ? e.target : e;
  if (!target.dataset.hiddenHref) {
    console.warn('No hiddenHref data attribute found on element:', target);
    return;
  }

  try {
    let deobfuscated = atob(target.dataset.hiddenHref);
    target.href = deobfuscated;
    // Optionally reveal the address as visible text too: either into a
    // dedicated child slot, or as the element's own text via data-hidden-text.
    const textSlot =
      target.querySelector('[data-hidden-text-slot]') ||
      ('hiddenText' in target.dataset ? target : null);
    if (textSlot) {
      textSlot.textContent = deobfuscated.replace(/^mailto:/, '').split('?')[0];
    }
    // Remove the obfuscation class to indicate it's been processed
    target.classList.remove('href-hidden');
    target.classList.add('href-deobfuscated');
  } catch (error) {
    console.error('Failed to deobfuscate email:', error);
  }
};

export function initEmailDeobfuscation() {
  const obfuscatedLinks = document.querySelectorAll('.href-hidden');

  obfuscatedLinks.forEach((link) => {
    if (link.dataset.hiddenInstantLoad === 'true') {
      deobfuscate(link);
    } else {
      const deobfuscateOnInteraction = () => {
        deobfuscate(link);
        link.removeEventListener('mouseenter', deobfuscateOnInteraction);
        link.removeEventListener('focus', deobfuscateOnInteraction);
      };

      link.addEventListener('mouseenter', deobfuscateOnInteraction);
      link.addEventListener('focus', deobfuscateOnInteraction);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEmailDeobfuscation);
} else {
  initEmailDeobfuscation();
}
